import React from 'react';

export const Gallery = React.lazy(() => import('./Gallery/ListGallery'));
export const AddGallery = React.lazy(() => import('./Gallery/AddGallery'));
export const EditGallery = React.lazy(() => import('./Gallery/EditGallery'));

export const ListPrestasi = React.lazy(() => import('./Prestasi/ListPrestasi'));
export const AddPrestasi = React.lazy(() => import('./Prestasi/AddPrestasi'));
export const EditPrestasi = React.lazy(() => import('./Prestasi/EditPrestasi'));

export const ListKarya = React.lazy(() => import('./Karya/ListKarya'));
export const AddKarya = React.lazy(() => import('./Karya/AddKarya'));
export const EditKarya = React.lazy(() => import('./Karya/EditKarya'));

export const ListVisiMisi = React.lazy(() => import('./VisiMisi/ListVisiMisi'));
export const AddVisiMisi = React.lazy(() => import('./VisiMisi/AddVisiMisi'));
export const EditVisiMisi = React.lazy(() => import('./VisiMisi/EditVisiMisi'));

export const ListStrukturOrganisasi = React.lazy(() => import('./StrukturOrganisasi/ListStrukturOrganisasi'));
export const AddStrukturOrganisasi = React.lazy(() => import('./StrukturOrganisasi/AddStrukturOrganisasi'));
export const EditStrukturOrganisasi = React.lazy(() => import('./StrukturOrganisasi/EditStrukturOrganisasi'));

export const ListSejarah = React.lazy(() => import('./Sejarah/ListSejarah'));
export const AddSejarah = React.lazy(() => import('./Sejarah/AddSejarah'));
export const EditSejarah = React.lazy(() => import('./Sejarah/EditSejarah'));

export const ListAlumni = React.lazy(() => import('./Alumni/ListAlumni'));
export const AddAlumni = React.lazy(() => import('./Alumni/AddAlumni'));
export const EditAlumni = React.lazy(() => import('./Alumni/EditAlumni'));

export const ListTupoksi = React.lazy(() => import('./Tupoksi/ListTupoksi'));
export const AddTupoksi = React.lazy(() => import('./Tupoksi/AddTupoksi'));
export const EditTupoksi = React.lazy(() => import('./Tupoksi/EditTupoksi'));

export const ListLegalitas = React.lazy(() => import('./Legalitas/ListLegalitas'));
export const AddLegalitas = React.lazy(() => import('./Legalitas/AddLegalitas'));
export const EditLegalitas = React.lazy(() => import('./Legalitas/EditLegalitas'));

export const ListAgenda = React.lazy(() => import('./Agenda/ListAgenda'));
export const AddAgenda = React.lazy(() => import('./Agenda/AddAgenda'));
export const EditAgenda = React.lazy(() => import('./Agenda/EditAgenda'));

export const ListKeasramaan = React.lazy(() => import('./Keasramaan/ListKeasramaan'));
export const AddKeasramaan = React.lazy(() => import('./Keasramaan/AddKeasramaan'));
export const EditKeasramaan = React.lazy(() => import('./Keasramaan/EditKeasramaan'));

export const ListKesiswaan = React.lazy(() => import('./Kesiswaan/ListKesiswaan'));
export const AddKesiswaan = React.lazy(() => import('./Kesiswaan/AddKesiswaan'));
export const EditKesiswaan = React.lazy(() => import('./Kesiswaan/EditKesiswaan'));

export const ListHumas = React.lazy(() => import('./Humas/ListHumas'));
export const AddHumas = React.lazy(() => import('./Humas/AddHumas'));
export const EditHumas = React.lazy(() => import('./Humas/EditHumas'));

export const ListTataUsaha = React.lazy(() => import('./TataUsaha/ListTataUsaha'));
export const AddTataUsaha = React.lazy(() => import('./TataUsaha/AddTataUsaha'));
export const EditTataUsaha = React.lazy(() => import('./TataUsaha/EditTataUsaha'));

export const ListSarana = React.lazy(() => import('./Sarana/ListSarana'));
export const AddSarana = React.lazy(() => import('./Sarana/AddSarana'));
export const EditSarana = React.lazy(() => import('./Sarana/EditSarana'));

export const ListKurikulum = React.lazy(() => import('./Kurikulum/ListKurikulum'));
export const AddKurikulum = React.lazy(() => import('./Kurikulum/AddKurikulum'));
export const EditKurikulum = React.lazy(() => import('./Kurikulum/EditKurikulum'));

export const ListProgram = React.lazy(() => import('./Program/ListProgram'));
export const AddProgram = React.lazy(() => import('./Program/AddProgram'));
export const EditProgram = React.lazy(() => import('./Program/EditProgram'));

export const EditLive = React.lazy(() => import('./Live/EditLive'));
export const LiveList = React.lazy(() => import('./Live/LiveList'));

export const ListBerita = React.lazy(() => import('./Berita/ListBerita'));
export const AddBerita = React.lazy(() => import('./Berita/AddBerita'));
export const EditBerita = React.lazy(() => import('./Berita/EditBerita'));

export const ListIklan = React.lazy(() => import('./Iklan/ListIklan'));
export const AddIklan = React.lazy(() => import('./Iklan/AddIklan'));
export const EditIklan = React.lazy(() => import('./Iklan/EditIklan'));

export const ListKomunitas = React.lazy(() => import('./Komunitas/ListKomunitas'));
export const AddKomunitas = React.lazy(() => import('./Komunitas/AddKomunitas'));
export const EditKomunitas = React.lazy(() => import('./Komunitas/EditKomunitas'));

export const SearchEngineSettings = React.lazy(() => import('./SearchEngine/SearchEngineSettings'));

export const ListMedsos = React.lazy(() => import('./Medsos/ListMedsos'));
export const AddMedsos = React.lazy(() => import('./Medsos/AddMedsos'));
export const EditMedsos = React.lazy(() => import('./Medsos/EditMedsos'));

export const ListKategori = React.lazy(() => import('./Kategori/ListKategori'));
export const AddKategori = React.lazy(() => import('./Kategori/AddKategori'));
export const EditKategori = React.lazy(() => import('./Kategori/EditKategori'));

export const Login = React.lazy(() => import('./Login'));

